import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { Box, Typography } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';

interface StaticMapProps {
  location: {
    coordinates: {
      lat: number;
      lng: number;
    }; // [longitude, latitude]
    zoom?: number;
  };
  height?: number | string;
  width?: number | string;
  showCoordinates?: boolean;
  borderRadius?: number | string;
}

const StaticMap: React.FC<StaticMapProps> = ({
  location,
  height = 200,
  width = '100%',
  showCoordinates = false,
  borderRadius = '16px'
}) => {
  // Convert coordinates to Google Maps format (latitude, longitude)
  const center = {
    lat: location?.coordinates?.lat || 0, // latitude
    lng: location?.coordinates?.lng || 0  // longitude
  };

  const mapContainerStyle = {
    width: width,
    height: height,
    borderRadius: borderRadius
  };

  const mapOptions = {
    zoom: location.zoom || 15,
    center: center,
    disableDefaultUI: true,
    gestureHandling: 'none',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    draggable: false,
    styles: [
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      }
    ]
  };

  // Google Maps API key should be in environment variable



  return (
    <Box sx={{ position: 'relative', height: height, width: width }}>
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={15}
          options={mapOptions}
        >
          <Marker 
            position={center}
            icon={{
              url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#FF4444"/>
                </svg>
              `),
              scaledSize: new window.google.maps.Size(32, 32),
              anchor: new window.google.maps.Point(16, 32)
            }}
          />
        </GoogleMap>
      
      {showCoordinates && (
        <Box sx={{ position: 'absolute', bottom: 8, left: 8 }}>
          <Typography variant="caption" sx={{ bgcolor: 'white', px: 1, py: 0.5, borderRadius: 1, boxShadow: 1 }}>
            {location?.coordinates?.lat || 0}, {location?.coordinates?.lng || 0}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default StaticMap; 